module.exports = __webpack_public_path__ + "static/media/HOW TO ADD A FAMILY MEMBERS.46bbdde7.png";